import React, { useState } from 'react';
import Image from 'next/image';
import { useLocale, useTranslations } from 'next-intl';
import type { LanguageCodeEnum } from '@/shared/config/common/constants/lang';
import { classNames } from '@/shared/lib/classnames/classnames';
import { getFormattedDate } from '@/shared/lib/date/getFormattedDate';
import { Button } from '@/shared/ui/button';
interface ReplyContentProps {
  authorName: string;
  avatar: string;
  text: string;
  createdAt: string;
}
export const ReplyContent: React.FC<ReplyContentProps> = ({
  authorName,
  avatar,
  text,
  createdAt
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const t = useTranslations('doctor.reviews');
  const locale = useLocale();
  const toggleExpanded = () => {
    setIsExpanded(prevState => !prevState);
  };
  return <>
      <div className="flex items-center">
        <Image loading="lazy" src={avatar} className="h-12 rounded-full object-cover" width={48} height={48} alt={`${t('in_photo')} ${authorName}`} data-sentry-element="Image" data-sentry-source-file="ReplyContent.tsx" />
        <div className="ml-4 flex w-full items-center justify-between">
          <p className="text-sm font-semibold">{authorName}</p>
          <p className="text-xs text-gray-500">
            <time dateTime={createdAt.toString()}>
              {getFormattedDate(createdAt, {
              locale: locale as LanguageCodeEnum,
              format: 'DD MMMM YYYY',
              capitalizeFirst: true
            })}
            </time>
          </p>
        </div>
      </div>
      <div className="mt-4 text-sm">
        <p className={classNames('', {
        'line-clamp-3': !isExpanded
      })}>{text}</p>
        {text.length > 100 && <div className="mt-1">
            <Button variant="text" onClick={toggleExpanded} textWeight="normal">
              {isExpanded ? `${t('hide')}` : `${t('expand')}`}
            </Button>
          </div>}
      </div>
    </>;
};